import config from './config.js';

export const mainLog = (...args) => {
  const cfg = config.getConfig();
  if (cfg.environment === 'dev') {
     
    console.log(...args);
  }
};